import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import Link from "next/link";
import { Folder } from "lucide-react";
import { cn } from "@repo/blacksmith-ui/cn";
import { draggedSessionId, isSessionDrag } from "./sessionProjectDrag";
export interface SidebarProject {
  id: string;
  name: string;
}

// The rest stay reachable from the Projects page and a row's Add to project menu.
const MAX_LISTED_PROJECTS = 8;
const DROP_TARGET_CLASS = "bg-black/[0.06] ring-1 ring-inset ring-[var(--focus-border)] dark:bg-white/[0.06]";

/**
 * The viewer's active projects under the Projects nav row. Each row is a drop
 * target for a session row dragged out of the list (see SessionItem).
 */
export function SidebarProjectRows(t0) {
  const $ = _c(20);
  const {
    projects,
    projectsHref,
    onDropSession,
    onNavigate,
    className,
    rowClassName,
    iconClassName
  } = t0;
  const [dropTargetId, setDropTargetId] = useState(null);
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== dropTargetId || $[3] !== iconClassName || $[4] !== onDropSession || $[5] !== onNavigate || $[6] !== projects || $[7] !== projectsHref || $[8] !== rowClassName) {
    let t3;
    if ($[10] !== dropTargetId || $[11] !== iconClassName || $[12] !== onDropSession || $[13] !== onNavigate || $[14] !== projectsHref || $[15] !== rowClassName) {
      t3 = project => {
        const isDropTarget = dropTargetId === project.id;
        return <li key={project.id}><Link href={`${projectsHref}/${project.id}`} onClick={onNavigate} draggable={false} onDragOver={e => {
            if (!onDropSession || !isSessionDrag(e)) {
              return;
            }
            e.preventDefault();
            e.dataTransfer.dropEffect = "move";
            setDropTargetId(project.id);
          }} onDragLeave={e_0 => {
            if (e_0.currentTarget.contains(e_0.relatedTarget as Node | null)) {
              return;
            }
            setDropTargetId(current => current === project.id ? null : current);
          }} onDrop={e_1 => {
            setDropTargetId(null);
            const sessionId = draggedSessionId(e_1);
            if (!onDropSession || !sessionId) {
              return;
            }
            e_1.preventDefault();
            onDropSession(sessionId, project.id);
          }} className={cn(rowClassName, isDropTarget && DROP_TARGET_CLASS)}><Folder className={iconClassName} /><span className="block min-w-0 flex-1 truncate text-left">{project.name}</span></Link></li>;
      };
      $[10] = dropTargetId;
      $[11] = iconClassName;
      $[12] = onDropSession;
      $[13] = onNavigate;
      $[14] = projectsHref;
      $[15] = rowClassName;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    t2 = projects.slice(0, MAX_LISTED_PROJECTS).map(t3);
    $[2] = dropTargetId;
    $[3] = iconClassName;
    $[4] = onDropSession;
    $[5] = onNavigate;
    $[6] = projects;
    $[7] = projectsHref;
    $[8] = rowClassName;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[17] !== t1 || $[18] !== t2) {
    t3 = <ul aria-label="Your projects" className={t1}>{t2}</ul>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  return t3;
}